module.exports = __webpack_public_path__ + "static/media/dog-1.9ea2ca91.jpg";